const productRecommendationsSection = document.querySelector('.product-recommendations');
if (productRecommendationsSection) {
  const url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }

        $('.related-products-slider .owl-carousel').each(function () {
          let $carousel = $(this);
          let $floatNav = $('.related-products-slider .float-nav');

          let owl = $carousel.owlCarousel({
            items: 4,
            nav: true,
            dots: false,
            smartSpeed: 800,
            loop: false,
            autoplay: false,
            autoplayTimeout: 5000,
            margin: 20,
            responsive: {
              0: {
                items: 1,
                stagePadding: 20
              },
              1000: {
                items: 3
              },
              1280: {
                items: 4
              }
            }
          }).on('changed.owl.carousel', function (event) {
            let currentIndex = event.item.index;
            let totalItems = event.item.count;
            let pageSize = event.page.size;

            if (currentIndex === 0) {
              // Optional: Disable prev if needed
            } else {
              $floatNav.find('.owl-prev').prop('disabled', false);
            }

            if (currentIndex >= totalItems - pageSize) {
              // Optional: Disable next if needed
            } else {
              $floatNav.find('.owl-next').prop('disabled', false);
            }
          });

          $floatNav.find('.owl-prev').on('click', function () {
            owl.trigger('prev.owl.carousel');
          });
          $floatNav.find('.owl-next').on('click', function () {
            owl.trigger('next.owl.carousel');
          });

          $carousel.trigger('refresh.owl.carousel');
        });
      
    })
    .catch(e => {
      console.error(e);
    });
}